import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
declare var $: any;
import * as _ from 'lodash';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { ChangeMasterService } from 'src/app/services/change-master.service';
@Component({
  selector: 'app-chg7list',
  templateUrl: './chg7list.component.html',
  styleUrls: ['./chg7list.component.css']
})
export class Chg7listComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfChargeMaster: DataTables.Settings = {};
  dtOptionsOfChargeMasterNew: DataTables.Settings = {};
  dtTriggerChargeMasterNew: Subject<any> = new Subject();
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerChargeMaster: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  dateOfSatisfaction: any;
  dateOfCreation; any;
  response: boolean;
  chargeHolderName: any;
  chargeId: any;
  deletechargeId: any;
  editChargeID: any;
  isSearchDivVisible = false;
  constructor(private chargeMasterService: ChangeMasterService, private router: Router, 
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['chg7','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');


    this.dtOptionsOfChargeMaster = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [13] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Charge Master',
          title: 'Charge Master',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 5, 6, 8, 10, 12],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    this.dtOptionsOfChargeMasterNew = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [13] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Charge Master',
          title: 'Charge Master',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 5, 6, 8, 10, 12],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    
    this.getRegisterDirectorList();
  }


  // loadDetailsById(directorId) {
  //   this.router.navigate(['/intern/edit/', directorId]);
  // }

  adjustdirectormasterTable() {
    var directorData = this.registerDirectorList;
    if (directorData.length) {
      this.registerDirectorList = [];
      $("#chargeMasterTable").DataTable().destroy();
      this.registerDirectorList = directorData;
      this.dtTriggerChargeMaster.next();
      this.dtTriggerChargeMasterNew.next();
      setTimeout(() => {
        $("#chargeMasterTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#chargeMasterTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.chargeMasterService.getChargeMaster({ isSearch: false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerChargeMaster.next();
      this.dtTriggerChargeMasterNew.next();
      // setTimeout(() => {
      //   this.dtTriggerChargeMaster.next();
      // }, 200);
    });
  }

  loadChargeDataById(chargemasterId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['chg7','edit',':_id',chargemasterId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/chg7/edit/:_id', chargemasterId]);
  }

  confirmDelete(id) {
    this.deletechargeId = id;
    $("#deleteConfirm").modal('toggle');
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfSatisfaction,
      toDate: this.dateOfCreation,
      name: this.chargeHolderName,
      param1: this.chargeId
    }
    this.chargeMasterService.generateChargeMaster(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.chargeMasterService.downloadChargeMasterFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.chargeMasterService.downloadChargeMasterPdfFile(id, 'Multi');
  }

  deleteChargeMasterdetail() {
    this.chargeMasterService.removeChargeMasterdetails(this.deletechargeId)
      .subscribe(response => {
        var self = this;
        if (response.status == 0) {
          self.alert.success(response.message);
          $("#chargeMasterTable").DataTable().destroy();
          $('#deleteConfirm').modal('toggle');
        } else {
          self.alert.error(response.message);
        }
        this.getRegisterDirectorList();
      });

  }

  editChargedetail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['chg7','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['chg7/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      'chargeId': this.chargeId,
      'chargeHolderName': this.chargeHolderName,
      "dateOfSatisfaction":this.setDate(this.dateOfSatisfaction),
      "dateOfCreation":this.setDate(this.dateOfCreation),
      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#chargeMasterTable").DataTable().destroy();
    this.chargeMasterService.getChargeMaster(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.registerDirectorList = registerList.data;
        this.dtTriggerChargeMaster.next();
        this.dtTriggerChargeMasterNew.next();
      }
    });
  }
  clearAdvSearch() {
    this.chargeId = undefined;
    this.chargeHolderName = undefined;
    this.dateOfSatisfaction = '';
    this.dateOfCreation = '';
    $("#chargeMasterTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }

}